Vue.directive('upload', {
    inserted: function (el, nodeObj) {

        var $input = el.getElementsByTagName('input');
        var $label = el.getElementsByTagName('span');

        $input[0].addEventListener('change', function(){

            $label[0].innerHTML = this.files[0].name;
        });
    }
});
